import { SpinLoading } from 'antd-mobile'
import './index.scss'

export default function Loading() {
    return (
        <div className='loading-container'>
            <SpinLoading color='primary' />
        </div>
    )
}